import {
  ExportOutlined,
  GlobalOutlined,
  LoadingOutlined,
  QuestionCircleFilled,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { Button, Col, Divider, Form, Input, Row, Select, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { APIProcessTransaction, validateConcurrentLogin } from "../../../Actions/api";
import { clearResponse } from "../../../Actions/message";
import jwt_decode from "jwt-decode";
import "./css/product.css";

function Sandbox(props) {
  const basePath = process.env.NODE_ENV === "production" ? "/api" : "";

  useEffect(() => {
    dispatch(clearResponse());
    if (props.productId !== 0) {
      if (props.product.length > 0) {
        for (var i = 0; i <= props.product.length - 1; i++) {
          var method = "POST";
          if (props.product[i].id === props.productId) {
            if (props.product[i].method === 2) {
              method = "GET";
            }
            try {
              if (method === "POST") {
                var request = JSON.parse(props.product[i].request);
                if (request === null) {
                  form.setFieldsValue({
                    request: "",
                  });
                } else {
                  form.setFieldsValue({
                    request: JSON.stringify(request, null, 5),
                  });
                }
              }else{
                form.setFieldsValue({
                  request: "",
                });
              }
            } catch {
              form.setFieldsValue({
                request: "",
              });
            }
            form.setFieldsValue({
              method: method,
              body: "JSON",
              inbound:
                window.location.origin +
                basePath +
                props.product[i].inbound,
            });
          }
        }
      }
    }
  }, [props.productId, props.product]);

  const { Option } = Select;
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { response } = useSelector((state) => state.message);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (response !== "") {
      form.setFieldsValue({
        response: JSON.stringify(response, null, 5),
      });
    } else {
      form.setFieldsValue({
        response: null,
      });
    }
    setLoading(false);
  }, [response]);

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  const handleConcurrentLogin = (token) => {
    if (token !== undefined) {
      let concurrencyLoginStamp = localStorage.getItem('ConcurrencyLoginStamp');
      if (token && concurrencyLoginStamp) {
        var decodePayload = jwt_decode(token);
        dispatch(validateConcurrentLogin(decodePayload.uid, concurrencyLoginStamp));
      }
    }
  }

  const onSubmit = (values) => {
    handleConcurrentLogin(props.token);
    form.setFieldsValue({
      response: "",
    });
    setLoading(true);
    dispatch(clearResponse());
    var replace = values.inbound.replace(
      window.location.origin + basePath, ""
    );
    try {
      var string = "{}";
      if (values.request !== "" && values.method !== "GET") {
        var request = JSON.parse(values.request);
        string = JSON.stringify(request);
      }
      dispatch(
        APIProcessTransaction(
          values.method,
          values.body,
          replace,
          string,
          values.APIToken
        )
      );
    } catch (error) {
      form.setFieldsValue({
        response: JSON.stringify(
          {
            Status: 1,
            Error: "Request required in JSON Type",
            Content: null,
            result: null,
          },
          null,
          5
        ),
      });
      setLoading(false);
    }
  };

  const changeToTokenPart = (e) => {
    props.focusProduct(2);
  };

  return (
    <div>
      <p className="product_doc_title">API Panel</p>
      <Form
        form={form}
        {...layout}
        layout="vertical"
        name="basic"
        style={{ margin: "20px 0px" }}
        onFinish={onSubmit}
      >
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={5} xl={5}>
            <Form.Item
              label={<label className="label_login">API Method</label>}
            >
              <Input.Group compact size="large">
                <div className="icon_selection">
                  {<UnorderedListOutlined />}
                </div>
                <Form.Item name="method" className="inputSelection">
                  <Select size="large" style={{ width: "100%" }}>
                    <Option value="POST">POST</Option>
                    <Option value="GET">GET</Option>
                  </Select>
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={5} xl={5}>
            <Form.Item label={<label className="label_login">Body</label>}>
              <Input.Group compact size="large">
                <div className="icon_selection">
                  {<UnorderedListOutlined />}
                </div>
                <Form.Item name="body" className="inputSelection">
                  <Select style={{ width: "100%" }} size="large">
                    <Option value="HTML">HTML</Option>
                    <Option value="JSON">JSON</Option>
                  </Select>
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={14} xl={14}>
            <Form.Item
              label={<label className="label_login">Endpoint</label>}
              name="inbound"
              rules={[
                {
                  required: true,
                  message: "Please input your InBound Endpoint!",
                },
              ]}
            >
              <Input addonBefore={<GlobalOutlined />} size="large" readOnly/>
            </Form.Item>
          </Col>
        </Row>
        <p className="product_doc_title" style={{ margin: "20px 0px" }}>
          Token
        </p>
        <Form.Item
          label={
            <label className="label_login">
              API Token{" "}
              <Tooltip placement="right" title="Redirect to Token Tab">
                <QuestionCircleFilled
                  size="large"
                  onClick={changeToTokenPart}
                />
              </Tooltip>
            </label>
          }
          name="APIToken"
          rules={[
            {
              required: true,
              message: "Please input your API Token!",
            },
          ]}
        >
          <Input addonBefore={<ExportOutlined />} size="large" />
        </Form.Item>
        <br />
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            className="button_login"
          >
            {loading && <LoadingOutlined />}
            SEND
          </Button>
        </Form.Item>
        <Divider />
        <div>
          <Row gutter={24}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <p
                className="product_doc_title"
                style={{ margin: "0px 0px 20px 0px" }}
              >
                Request
              </p>
              <Form.Item name="request">
                <TextArea rows={15} className="textarea"></TextArea>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <p
                className="product_doc_title"
                style={{ margin: "0px 0px 20px 0px" }}
              >
                Response
              </p>
              <Form.Item name="response">
                <TextArea rows={15} className="textarea" readOnly></TextArea>
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
    </div>
  );
}

export default Sandbox;
